import {
    Store
} from 'vuex';
import {
    IGlobalState
} from '@/store';
import * as Types from '@/store/action-types';

/**
 * 使用应用列表
 */
export async function useApplicationList(store: Store<IGlobalState>, userId: string,  keyWord: string, shelfState: number, page: number, limit: number) {
    await store.dispatch(`frontApp/${Types.SET_APPLICATION_LIST}`,
        {
            userId:userId,
            keyWord: keyWord,
            shelfState: shelfState,
            page: page,
            limit: limit
        });
};

/**
 * 根据应用id获取应用详情
 */
export async function useApplicationInfo(store: Store<IGlobalState>, appId: any) {
    await store.dispatch(`frontApp/${Types.SET_APPLICATION_INFO}`,
        {
            id:appId
        });
}

/**
 * 根据应用id获取应用下已授权学校列表
 */
export async function useAppAuthedSchool(store: Store<IGlobalState>, userId: string,appId: any,examineState: number,keyWord: string,authType: number,page: number, limit: number) {
    await store.dispatch(`frontApp/${Types.SET_APPLICATION_AUTHED_SCHOOL_LIST}`,
        {
            userId:userId,
            appId:appId,
            examineState:examineState === -1 ? '':examineState,
            keyWord: keyWord,
            type: authType,
            page: page,
            limit: limit
        });
}
